import { render, staticRenderFns } from "./CompanyAssetNote.vue?vue&type=template&id=0212c47b&scoped=true"
import script from "./CompanyAssetNote.vue?vue&type=script&lang=js"
export * from "./CompanyAssetNote.vue?vue&type=script&lang=js"
import style0 from "./CompanyAssetNote.vue?vue&type=style&index=0&id=0212c47b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0212c47b",
  null
  
)

export default component.exports